// API مربوط به «برگه بازرسی خودرو»
// نگاشت مستقیم روی routes/vehicleInspectionRouter.js:
//   POST   /api/v2/vehicle-inspection        -> createVehicleInspection
//   GET    /api/v2/vehicle-inspection         -> getAllVehicleInspections
//   GET    /api/v2/vehicle-inspection/:id     -> getVehicleInspection

import { httpClient } from "./httpClient";

// ثبت یک برگه بازرسی جدید (نیاز به لاگین دارد - auth middleware)
export function createVehicleInspection(payload) {
  return httpClient.post("/vehicle-inspection", payload);
}

// دریافت لیست برگه‌های بازرسی (با صفحه‌بندی اختیاری)
export function getAllVehicleInspections({ page = 1, limit = 10 } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  return httpClient.get(`/vehicle-inspection?${params.toString()}`);
}

// دریافت جزئیات یک برگه بازرسی با شناسه
export function getVehicleInspectionById(inspectionId) {
  return httpClient.get(`/vehicle-inspection/${inspectionId}`);
}
